import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Wrapper = styled(FlexBox)`
    width: 100%;
    height: calc(25vw);
    justify-content: center;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        margin-top: 8px!important;
    }
`;

const Text = styled.div`
    padding-top: 120px;
    color: ${Colors.galBlack47};
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
    
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;
        text-align: center;
    }
`;
const Content = styled.div`
    padding-top: 72px;
    color: ${Colors.galBlack47};
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.m_1024 - 1}px) {
        font-size: 23px;
        line-height: 29px;
        padding-top: 80px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 20px;
        line-height: 25px;
        padding-top: 64px;
    }
`;

const TextCompetition = styled(Text)`
    padding-top: 96px;
`;

export const EmptyCategory: FC<{ text?: string }> = ({ text }) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <Text>{text || t('empty_category')}</Text>
        </Wrapper>
    )
}

export const EmptyCompetitionProject: FC<{ text?: string }> = ({ text }) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <TextCompetition>{text || t('empty_category')}</TextCompetition>
        </Wrapper>
    )
}

export const EmptyCompetitionPage: FC<{text?: string}> = ({text}) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <Content>{text || t('empty_category')}</Content>
        </Wrapper>
    )
}import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Wrapper = styled(FlexBox)`
    width: 100%;
    height: calc(25vw);
    justify-content: center;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        margin-top: 8px!important;
    }
`;

const Text = styled.div`
    padding-top: 120px;
    color: ${Colors.galBlack47};
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
    
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;
        text-align: center;
    }
`;
const Content = styled.div`
    padding-top: 72px;
    color: ${Colors.galBlack47};
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.m_1024 - 1}px) {
        font-size: 23px;
        line-height: 29px;
        padding-top: 80px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 20px;
        line-height: 25px;
        padding-top: 64px;
    }
`;

const TextCompetition = styled(Text)`
    padding-top: 96px;
`;

export const EmptyCategory: FC<{ text?: string }> = ({ text }) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <Text>{text || t('empty_category')}</Text>
        </Wrapper>
    )
}

export const EmptyCompetitionProject: FC<{ text?: string }> = ({ text }) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <TextCompetition>{text || t('empty_category')}</TextCompetition>
        </Wrapper>
    )
}

export const EmptyCompetitionPage: FC<{text?: string}> = ({text}) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <Content>{text || t('empty_category')}</Content>
        </Wrapper>
    )
}